// Mock data for Ubiratan Amorim Tattoo Studio

export const heroData = {
  image: "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/8510b3kw_ChatGPT%20Image%2015%20de%20jan.%20de%202026%2C%2018_20_29.png",
  title: "Ubiratan Tattoo Studio",
  subtitle: "A tatuagem não é apenas estética; é o estudo constante da forma, da técnica e o respeito pela história que o cliente carrega na pele.",
  tattooWorks: [
    "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/nlrudh8r_003.jpeg",
    "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/3fg9ntrl_ChatGPT%20Image%2015%20de%20jan.%20de%202026%2C%2021_14_36.png",
    "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/7lnwevi0_DSC00350.JPG",
    "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/9pblsgrh_Gemini_Generated_Image_cl4tqtcl4tqtcl4t.png",
    "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/09dtlrs8_Gemini_Generated_Image_gi9q70gi9q70gi9q.png",
    "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/a2cs64ac_Gemini_Generated_Image_2sb1zi2sb1zi2sb1.png",
    "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/r17ihv8r_Gemini_Generated_Image_92odzx92odzx92od.png",
    "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/i7o9w7bx_Gemini_Generated_Image_7ot9f07ot9f07ot9.png"
  ]
};

export const tattooCategories = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/2eqt6svh_003.JPG",
    title: "Mickey Art",
    instagramUrl: "https://www.instagram.com/p/DRLBEq6kiLA/",
    description: "Foram 03 longos dias de evento pra se tornar real esse projetão. Sou grato a Deus por estar sempre comigo. Quero agradecer a minha equipe, que esteve sempre presente e me dando todo o suporte necessário. Agradecer a cada um que passou no Stand, que vibrou e emanou boas energias. A @theink.colors pelos excelentes pigmentos e materiais e claro, a @tattooweek por mais um ano incrível junto com a gente 🚀🙏🏾"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/ma9jo4aa_DSC00350.JPG",
    title: "Super Mario para sempre na pele",
    instagramUrl: "https://www.instagram.com/p/DOzBROSEjwa/",
    description: "Uma homenagem clássica ao encanador mais amado dos videogames — Super Mario — eternizado na pele com cor, personalidade e nostalgia. Essa tattoo capta a energia dos jogos: aventura, superação e aquela sensação de voltar à infância toda vez que olha. Cada traço remete às fases, moedas, blocos e ao ícone que atravessou gerações e culturas. Não é só um personagem — é um símbolo de alegria, determinação e diversão ilimitada."
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/09dtlrs8_Gemini_Generated_Image_gi9q70gi9q70gi9q.png",
    title: "Iguana Colorida",
    instagramUrl: "",
    description: ""
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/uvlhty2i_copy_C704DA98-E910-40B8-A8B7-B9F1B83C9927.jpeg",
    title: "Bebê em Realismo – Amor Eterno na Pele",
    instagramUrl: "https://www.instagram.com/reel/DRxn4jgkmr9/",
    description: "Uma tatuagem que traduz o amor mais puro que existe. O realismo do bebê na pele carrega cada detalhe com suavidade e sensibilidade: o olhar, as expressões, a textura da pele e a inocência de um momento único que jamais se repete. É uma arte feita para eternizar um vínculo que não se mede, não se explica — apenas se sente.\n\nEssa tattoo representa amor incondicional, proteção, família e eternidade. Mais do que uma imagem, é uma lembrança viva, um marco de vida gravado para sempre, carregado de emoção, significado e verdade."
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/kesyz92l_DSC01200.jpeg",
    title: "São Miguel Arcanjo – Protetor e Guerreiro",
    instagramUrl: "https://www.instagram.com/reel/DSYNACFEklB/",
    description: "Representando a força divina, a justiça e a proteção contra todo mal, a tatuagem de São Miguel Arcanjo carrega um significado profundo de fé e coragem. Com sua espada erguida e postura firme, ele simboliza a luta constante entre o bem e o mal, sendo o guardião daqueles que buscam proteção espiritual e equilíbrio.\n\nEssa tattoo vai além da arte: é um escudo espiritual, um lembrete diário de que a fé fortalece, protege e guia os caminhos. São Miguel Arcanjo representa a vitória da luz sobre as sombras, trazendo segurança, determinação e confiança para quem carrega sua imagem na pele."
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/xur3c9mi_DSC01048.jpeg",
    title: "Leões – Força, União e Liderança",
    instagramUrl: "https://www.instagram.com/reel/DSBBawQkqFF/",
    description: "A tatuagem de vários leões representa a união da força com a proteção. Cada leão simboliza coragem, poder e liderança, mas juntos eles carregam um significado ainda mais profundo: família, irmandade, lealdade e proteção mútua. É a imagem do instinto de cuidar, defender e permanecer firme diante de qualquer desafio.\n\nEssa tattoo expressa domínio emocional, respeito e equilíbrio entre força e sabedoria. Os leões juntos representam quem lidera sem oprimir, protege sem hesitar e enfrenta a vida com honra e determinação."
  },
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/9pblsgrh_Gemini_Generated_Image_cl4tqtcl4tqtcl4t.png",
    title: "Buda Dourado",
    instagramUrl: "",
    description: ""
  },
  {
    id: 8,
    image: "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/a2cs64ac_Gemini_Generated_Image_2sb1zi2sb1zi2sb1.png",
    title: "Caveira em Chamas",
    instagramUrl: "",
    description: ""
  },
  {
    id: 9,
    image: "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/r17ihv8r_Gemini_Generated_Image_92odzx92odzx92od.png",
    title: "Woody - Toy Story",
    instagramUrl: "",
    description: ""
  },
  {
    id: 10,
    image: "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/i7o9w7bx_Gemini_Generated_Image_7ot9f07ot9f07ot9.png",
    title: "Madre Teresa",
    instagramUrl: "",
    description: ""
  }
];

// Carrossel de Estilos
export const tattooStyles = [
  {
    id: 1,
    name: "Fine Line",
    image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/cj1ovkww_001%20%281%29.JPG",
    whatsappMessage: "Olá! Gostaria de um orçamento para tatuagem estilo Fine Line."
  }
];

// Escola de Tattoo
export const schoolData = {
  title: "Ubiratan School",
  subtitle: "Transforme sua paixão em profissão",
  description: "Aprenda a arte da tatuagem com quem entende. Mais de 30 prêmios em convenções, técnicas exclusivas e acompanhamento personalizado para você se tornar um artista completo.",
  image: "https://customer-assets.emergentagent.com/job_19ea5acf-a0bd-410d-ba59-3e2b00d198ba/artifacts/5aya9yli_image.png",
  whatsappMessage: "Olá! Gostaria de saber mais sobre o curso da Ubiratan Tattoo School."
};

export const studentWorks = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/hwnfywvq_IMG_9827.jpg"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/sef1g347_IMG_7954.jpg"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/ebxcqn8j_IMG_8518.jpg"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/hcpvqs4d_IMG_8516.jpg"
  }
];

export const aboutData = {
  title: "Sobre o Estúdio",
  subtitle: "Ubiratan Amorim",
  description: `Você já sentiu o medo de confiar sua pele a alguém e o resultado não ser o que você sonhou? Nós entendemos que uma tatuagem não é apenas um desenho; é a materialização de um momento, de uma conquista ou de uma identidade.

Com mais de 30 prêmios em convenções nacionais e internacionais, Ubiratan Amorim fundou seu studio baseado em um conceito Private: atendimento exclusivo, focado nos mínimos detalhes e na biossegurança absoluta. O que começou na zona leste de São Paulo hoje é um dos maiores complexos de tatuagem do país, unindo luxo, arte e técnica de alta performance.

Aqui, você não é apenas mais um horário na agenda. Você é o protagonista de uma obra de arte única, executada com os melhores insumos do mercado e por artistas que dominam a anatomia e a durabilidade do pigmento na pele.`,
  image: "https://customer-assets.emergentagent.com/job_3f94c237-bce3-4f5a-a151-d09057fdbab3/artifacts/4k5txjgc_3627e775-cffa-44a3-85de-139bbad52e51.jpg"
};

export const locationData = {
  address: "R. Prof. João de Oliveira Torres, 405",
  city: "Jardim Anália Franco, São Paulo - SP",
  postalCode: "CEP: 03337-010",
  fullAddress: "R. Prof. João de Oliveira Torres, 405 - Jardim Anália Franco, São Paulo - SP, 03337-010",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.2!2d-46.5547!3d-23.5614!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce5fb2c15797a7%3A0x8a1234567890!2sR.%20Prof.%20Jo%C3%A3o%20de%20Oliveira%20Torres%2C%20405%20-%20Jardim%20An%C3%A1lia%20Franco%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2003337-010!5e0!3m2!1spt-BR!2sbr!4v1700000000000!5m2!1spt-BR!2sbr"
};

export const contactData = {
  phone: "(11) 99004-7930",
  whatsapp: "5511990047930",
  email: "recepcao.estudioubiratan@gmail.com",
  instagram: "ubiratantattoostudio",
  facebook: "UbiratanTattooStudio"
};

export const navigationLinks = [
  { id: 1, label: "Início", href: "#home" },
  { id: 2, label: "Estilos", href: "#estilos" },
  { id: 3, label: "Escola", href: "#escola" },
  { id: 4, label: "Sobre", href: "#sobre" },
  { id: 5, label: "Localização", href: "#localizacao" },
  { id: 6, label: "Tour 360", href: "#tour" },
  { id: 7, label: "Contato", href: "#contato" }
];
